module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/artefato/operacao/operacao.component.css
// module id = ./src/app/artefato/operacao/operacao.component.css
// module chunks = main